import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface AuthenticatedUser {
  userId: number;
  baseRoleId: number;
  roleId: number;
  entityId: number;
  projectId: number;
  securityGroupId: number;
  landingPage: string;
  token: string;
  uuid?: string;
  emailID?: string;
  roleName?: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
}

interface AuthenticatedUserState {
  user: AuthenticatedUser;
}

const initialState: AuthenticatedUserState = {
  user: null,
};

const authenticatedUserSlice = createSlice({
  name: 'authenticatedUser',
  initialState,
  reducers: {
    setAuthenticatedUser: (state, action: PayloadAction<AuthenticatedUser>) => {
      state.user = action.payload;
    },
    clearAuthenticatedUser: (state) => {
      state.user = null;
    },
  },
});

export const {setAuthenticatedUser, clearAuthenticatedUser} =
  authenticatedUserSlice.actions;

export default authenticatedUserSlice.reducer;
